import HeartLanding from './HeartLanding';
export default HeartLanding;
